// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/release-cloudweb-14614-118-2-2.202212271609/" + chunkId + ".js";
};